import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Input,
  Select,
  Button,
  Checkbox,
  Upload,
  Modal,
  Divider,
  InputNumber,
  Popconfirm,
  Switch,
  notification,
} from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import menuConfigurationActions from "../../../../redux/menuConfiguration/actions";

const { editMenuItem, updateMenuItemImages } = menuConfigurationActions;

const MenuConfigurationMenuEditModal = ({
  record,
  openMenuItemEditModal,
  setOpenMenuItemEditModal,
}) => {
  const { TextArea } = Input;
  const dispatch = useDispatch();
  const organizationId = localStorage.getItem("organizationId");

  const { categories, menuItemImage, itemsTags } = useSelector(
    (state) => state.menuConfigurationReducer
  );
  const { menuConfiguration } = useSelector(
    (state) => state.organizationsReducer
  );
  const [name, setName] = useState(null);
  const [menuText, setMenuText] = useState(null);
  const [information, setInformation] = useState(null);
  const [kcal, setKcal] = useState(null);
  const [itemSortIndex, setItemSortIndex] = useState(null);
  const [menuCategoryId, setMenuCategoryId] = useState(null);
  const [myMenuActive, setMyMenuActive] = useState(null);
  const [tags, setTags] = useState(null);

  const defaultOrganizatoinLanguage = menuConfiguration?.defaultLanguage;

  // Helper function to extrack initial Values
  const extractImageData = (url) => {
    const regex = /(\d+)_(\w+)_(\d+)_(\w+)\.webp$/;
    const match = url.match(regex);

    if (!match) return null;

    const [, itemId, oldImageSource, oldImageSortIndex, oldImageMyMenuFlag] =
      match;
    return {
      image: url, // Replace this with the actual image data (e.g., base64) if needed
      itemId: parseInt(itemId, 10),
      oldImageSortIndex: parseInt(oldImageSortIndex, 10),
      newImageSortIndex: parseInt(oldImageSortIndex, 10),
      oldImageMyMenuFlag: oldImageMyMenuFlag === "t",
      newImageMyMenuFlag: oldImageMyMenuFlag === "t",
      oldImageSource: oldImageSource,
      newImageSource: oldImageSource,
      delete: false,
    };
  };

  // Initialize state using the processed data
  const [imagesState, setImagesState] = useState([]);

  const updateImageState = (index, updates) => {
    setImagesState((prevState) =>
      prevState.map((image, idx) =>
        idx === index ? { ...image, ...updates } : image
      )
    );
  };

  const uploadImage = (e, index) => {
    const selectedFile = e.file;
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
    const filesize = Number((selectedFile.size / 1024 / 1024).toFixed(4)); // MB

    if (!allowedTypes.includes(selectedFile?.type)) {
      notification["error"]({
        message:
          "Можете да качите само файлове, които са тип .jpg .jpeg .png .webp",
      });
      return;
    }

    if (filesize > 20) {
      notification["error"]({
        message: "Големината на снимката трябва да е под 20мб",
      });
      return;
    }

    const data = new FileReader();
    data.addEventListener("load", () => {
      if (index !== undefined) {
        // If index is defined, update the existing image at the specified index
        updateImageState(index, { image: data.result });
      } else {
        setImagesState((prevState) => {
          return [
            ...prevState, // keep the existing elements
            {
              image: data.result,
              itemId: record.itemId,
              oldImageSortIndex: 10,
              newImageSortIndex: 10,
              oldImageMyMenuFlag: true,
              newImageMyMenuFlag: true,
              oldImageSource: "port",
              newImageSource: "port",
              delete: false,
              new: true, // Add new property when add a new image
            },
          ];
        });
      }
    });
    data.readAsDataURL(selectedFile);
  };

  // Validation for images to have unique sortIndex and only one with 'ts'
  function validateImagesState(imagesState) {
    if (imagesState.length > 0) {
      // Check if there's only one element with newImageSource === 'ts'
      const tsElements = imagesState.filter(
        (item) => item.newImageSource === "ts"
      );
      if (tsElements.length > 1) {
        notification["error"]({
          message: "Трябва да има само една Основна снимка",
        });
        return false;
      }

      // Check if all newImageSortIndex values are unique
      const sortIndexes = imagesState.map((item) => item.newImageSortIndex);
      const uniqueSortIndexes = new Set(sortIndexes);
      if (uniqueSortIndexes.size !== sortIndexes.length) {
        notification["error"]({
          message: "Всички сорт индекси трябва да бъдат уникални",
        });
        return false;
      }
    }

    return true;
  }

  // 1 is when read image from get
  // 2 is when upload new image
  const updateMenuItem = () => {
    const imagesValidation = validateImagesState(imagesState);
    if (imagesValidation) {
      dispatch(
        editMenuItem({
          item: {
            itemId: record.itemId,
            name,
            menuText,
            information,
            kcal,
            itemSortIndex,
            menuCategoryId,
            myMenuActive:
              myMenuActive === null ? record.myMenuActive : myMenuActive[0],
            tags: editArrayTags,
          },
          organizationId,
        })
      );

      if (imagesValidation) {
        const imageStateForRequest = imagesState.map((item) => {
          const updatedItem = {
            ...item,
            image: item.image.startsWith("data:image")
              ? item.image.split(",")[1]
              : null,
            newImageMyMenuFlag:
              item.oldImageMyMenuFlag === item.newImageMyMenuFlag
                ? null
                : item.newImageMyMenuFlag,
            newImageSortIndex:
              item.oldImageSortIndex === item.newImageSortIndex
                ? null
                : item.newImageSortIndex,
            newImageSource:
              item.oldImageSource === item.newImageSource
                ? null
                : item.newImageSource,
          };

          if (item.new) {
            if (updatedItem.newImageMyMenuFlag !== null) {
              updatedItem.oldImageMyMenuFlag = updatedItem.newImageMyMenuFlag;
              updatedItem.newImageMyMenuFlag = null;
            }
            if (updatedItem.newImageSortIndex !== null) {
              updatedItem.oldImageSortIndex = updatedItem.newImageSortIndex;
              updatedItem.newImageSortIndex = null;
            }
            if (updatedItem.newImageSource !== null) {
              updatedItem.oldImageSource = updatedItem.newImageSource;
              updatedItem.newImageSource = null;
            }

            // Remove the 'new' property
            delete updatedItem.new;
          }

          return updatedItem;
        });
        dispatch(updateMenuItemImages(imageStateForRequest));
      }
      closeMenuItemEditModal();
    }
  };

  const closeMenuItemEditModal = () => {
    setOpenMenuItemEditModal(false);
    setImagesState([]);
  };

  const categoriesSelect = categories.map((item) => {
    return { label: item.name, value: item.id };
  });

  const handleAddTags = (value) => {
    setTags(value);
  };

  const editArrayTags = tags?.map((tag) => {
    return {
      tagId: tag,
      itemId: record.itemId,
    };
  });

  const tagsSelectOptions = itemsTags?.map((tag) => {
    const defaultLanguageTag = tag.languages?.find(
      (tag) => tag.abbreviation === defaultOrganizatoinLanguage
    )?.value;
    return {
      label: defaultLanguageTag ? defaultLanguageTag : tag.languages[0].value,
      value: tag.tagId,
    };
  });

  useEffect(() => {
    setName(record.name);
    setMenuText(record.menuText);
    setInformation(record.information);
    setKcal(record.kcal);
    setItemSortIndex(record.itemSortIndex);
    setMenuCategoryId(record.menuCategoryId);
    setTags(record?.tags?.map((tag) => tag.tagId));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record, openMenuItemEditModal]);

  useEffect(() => {
    setImagesState(
      menuItemImage?.imagesPaths?.map(extractImageData).filter(Boolean) || []
    );
  }, [menuItemImage, record]);

  return (
    <Modal
      className="menu-configuration-menu-edit-modal"
      onCancel={closeMenuItemEditModal}
      width="700px"
      centered
      open={openMenuItemEditModal}
      footer={
        <div className="menu-configuration-menu-edit-modal-footer">
          <Button onClick={closeMenuItemEditModal}>Затвори</Button>
          <Button type="primary" onClick={updateMenuItem}>
            Запази
          </Button>
        </div>
      }
    >
      <div className="menu-configuration-menu-items-edit-container">
        <div className="menu-configuration-containers">
          <div className="menu-configuration-menu-items-edit-items">
            <div className="menu-configuration-menu-items-edit-text-name">
              <h4>
                Име{" "}
                <span className="menu-configuration-menu-items-item-id">
                  {record.itemId}
                </span>
              </h4>
            </div>
            <Input
              onChange={(e) => setName(e.target.value)}
              value={name}
              className="menu-configuration-menu-items-edit-input-product-name"
            />
          </div>

          <div className="menu-configuration-menu-items-edit-items">
            <div className="menu-configuration-menu-items-edit-text-name">
              <h4>Информация</h4>
            </div>
            <TextArea
              onChange={(e) => setInformation(e.target.value)}
              value={information}
              id="menu-configuration-menu-items-edit-textarea"
              autoSize={{
                minRows: 4,
                maxRows: 4,
              }}
            />
          </div>

          <div className="menu-configuration-menu-items-edit-items">
            <div className="menu-configuration-menu-items-edit-text-name">
              <h4>Група</h4>
            </div>
            <Select
              onChange={(e) => setMenuCategoryId(e)}
              value={menuCategoryId}
              className="menu-configuration-menu-items-edit-input-group-field"
              options={categoriesSelect}
            />
          </div>
          <div className="menu-configuration-menu-items-edit-items">
            <div className="menu-configuration-menu-items-edit-text-name">
              <h4>Тагове</h4>
            </div>
            <Select
              className="menu-configuration-menu-items-edit-input-group-field"
              mode="multiple"
              showSearch
              value={tags}
              options={tagsSelectOptions}
              onChange={handleAddTags}
            />
          </div>
          <div className="menu-configuration-menu-items-edit-checkboxes">
            <Checkbox.Group
              value={
                myMenuActive === null
                  ? record.myMenuActive === 3
                    ? [1, 2]
                    : [record.myMenuActive]
                  : myMenuActive[0] === 3
                  ? [1, 2]
                  : myMenuActive
              }
              onChange={(e) => {
                setMyMenuActive(
                  e.length === 0
                    ? [0]
                    : [
                        e.reduce(
                          (accumulator, currentValue) =>
                            accumulator + currentValue,
                          0
                        ),
                      ]
                );
              }}
            >
              <div className="menu-configuration-menu-items-edit-items">
                <h4>MyMenu</h4>
                <Checkbox value={1}></Checkbox>
              </div>

              <div className="menu-configuration-menu-items-edit-items">
                <h4>MyDelivery</h4>
                <Checkbox value={2}></Checkbox>
              </div>
            </Checkbox.Group>
          </div>
        </div>

        <div className="menu-configuration-containers">
          <div className="menu-configuration-menu-items-edit-items">
            <div className="menu-configuration-menu-items-edit-text-name">
              <h4>Грамаж</h4>
            </div>
            <Input
              onChange={(e) => setMenuText(e.target.value)}
              value={menuText}
              className="menu-configuration-menu-items-edit-input"
            />
          </div>
          <div className="menu-configuration-menu-items-edit-items">
            <div className="menu-configuration-menu-items-edit-text-name">
              <h4>Калории</h4>
            </div>
            <Input
              onChange={(e) => setKcal(e.target.value)}
              value={kcal}
              className="menu-configuration-menu-items-edit-input"
            />
          </div>

          <div className="menu-configuration-menu-items-edit-items">
            <div className="menu-configuration-menu-items-edit-text-name">
              <h4>Сорт Индекс</h4>
            </div>
            <Input
              className="menu-configuration-menu-items-edit-input"
              onChange={(e) => setItemSortIndex(e.target.value)}
              value={itemSortIndex}
            />
          </div>
        </div>
      </div>
      <Divider />
      <div className="menu-configuration-menu-items-edit-image">
        <Upload
          showUploadList={false}
          onChange={(e) => uploadImage(e)}
          accept="image/png,image/jpeg,image/webp"
          beforeUpload={() => false}
        >
          <Button
            className="menu-configuration-edit-upload-button"
            icon={<UploadOutlined />}
          >
            Качи снимка
          </Button>
        </Upload>
        {imagesState?.map((image, index) => (
          <div
            className="menu-configuration-images-information-container"
            style={{ opacity: image.delete ? 0.5 : 1 }}
            key={index}
          >
            <div className="menu-configuration-images-information-sections">
              <img
                alt="menuImage"
                style={{
                  maxWidth: "100px",
                  maxHeight: "100px",
                }}
                src={image.image}
              />
            </div>
            <div className="menu-configuration-images-information-sections">
              <p>Сорт Индекс:</p>
              <InputNumber
                className="menu-configuration-edit-upload-images-sort-index"
                size="small"
                min={1}
                controls={false}
                disabled={image.delete}
                value={image.newImageSortIndex}
                onChange={(value) =>
                  updateImageState(index, { newImageSortIndex: value })
                }
                parser={(value) =>
                  parseInt(value.replace(/[^\d]/g, ""), 10) || 0
                } // Remove non-numeric characters
              />
            </div>
            <div className="menu-configuration-images-information-sections">
              <Checkbox
                checked={image.newImageMyMenuFlag}
                disabled={image.delete}
                onChange={(e) =>
                  updateImageState(index, {
                    newImageMyMenuFlag: e.target.checked,
                  })
                }
              >
                Активна
              </Checkbox>
            </div>
            <div className="menu-configuration-images-information-sections">
              <Switch
                checked={image.newImageSource === "ts"}
                disabled={image.delete}
                checkedChildren="TouchSale"
                unCheckedChildren="Portal"
                onChange={(checked) =>
                  updateImageState(index, {
                    newImageSource: checked ? "ts" : "port",
                  })
                }
              />
            </div>
            <div className="menu-configuration-images-information-sections">
              {/* <UploadOutlined className="menu-configuration-edit-upload-images-delete-icon" /> */}
              <Upload
                showUploadList={false}
                onChange={(e) => uploadImage(e, index)}
                accept="image/png,image/jpeg,image/webp"
                beforeUpload={() => false}
                disabled={image.delete}
              >
                <UploadOutlined className="menu-configuration-edit-upload-images-delete-icon" />
              </Upload>
            </div>
            <div className="menu-configuration-images-information-sections">
              <Popconfirm
                title="Изтриване на снимка"
                description="Сигурни ли сте, че искате да изтриете тази снимка?"
                onConfirm={() =>
                  updateImageState(index, {
                    delete: true,
                  })
                }
                okText="Да"
                cancelText="Не"
                disabled={image.newImageSource === "ts" || image.delete}
              >
                <DeleteOutlined
                  className="menu-configuration-edit-upload-images-delete-icon"
                  style={{
                    cursor:
                      image.newImageSource === "ts" || image.delete
                        ? "not-allowed"
                        : "pointer",
                    opacity:
                      image.newImageSource === "ts" || image.delete ? 0.5 : 1,
                  }}
                />
              </Popconfirm>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default MenuConfigurationMenuEditModal;
